// Example <Timer :seconds="9" :watch="homeLoan" @run="saveDiagram" />
<template>
<span>
    <template v-if="remaining < 1">
        Saved   
    </template>
    <template v-else>
        Saving in {{remaining}}s...   
        <a @click="remaining = 0">Save Now</a> | 
        <a @click="revert">Revert</a>
    </template>
</span>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'

export default {
    data() {
        return {
            remaining: 0,
            timerHandle: null,
        }
    },

    components: {
        
    },
    
    props: {
        seconds: Number,
        watch: [Object, String, Number]
    },

    computed: {
        timerText() {
            if(this.remaining)
                return 'Saving in ' + this.remaining + 's'
            else
                return 'Saved'
        }
    },

    methods: {
        revert() {
            AlertHelpers.showAlert('Cannot revert yet')
        },

        start() {
            this.remaining = this.seconds
            if(!this.timerHandle) {
                this.timerHandle = setInterval( () => {
                    this.remaining -= 1
                    if(this.remaining <= 0) {
                        this.stop()
                        this.run()
                    }

                }, 1000)
            }
        },

        stop() {
            clearInterval(this.timerHandle)
            this.timerHandle = null
            this.remaining = 0
        },

        run() {
            this.$emit('run', this.watch)
        }
        
    },

    watch: {
        'watch': {
            handler: function(newVal) {
                this.start()
            },
            deep: true,
        }
    },

    beforeDestroy() {
        if(this.timerHandle)
            this.run()
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// Timer.vue?485a9bbf